import { render, staticRenderFns } from "./ProgrammAccent.vue?vue&type=template&id=351d1764&scoped=true"
import script from "./ProgrammAccent.vue?vue&type=script&lang=js"
export * from "./ProgrammAccent.vue?vue&type=script&lang=js"
import style0 from "./ProgrammAccent.vue?vue&type=style&index=0&id=351d1764&prod&scoped=true&lang=css"
import style1 from "./ProgrammAccent.vue?vue&type=style&index=1&id=351d1764&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351d1764",
  null
  
)

export default component.exports